<template>
    <DefaultField :field="currentField" :errors="errors" :show-help-text="showHelpText">
        <template #field>
            <input
                :id="currentField.attribute"
                type="text"
                inputmode="numeric"
                class="w-full form-control form-input form-input-bordered"
                :class="errorClasses"
                :placeholder="currentField.name"
                v-model="displayValue"
                @input="handleInput"
            />
            <p v-if="numbersText" class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {{ numbersText }}
            </p>
        </template>
    </DefaultField>
</template>

<script>
import { DependentFormField, HandlesValidationErrors } from '@/mixins'
import numeral from 'numeral'
import pn from 'persian-number'

export default {
    mixins: [DependentFormField, HandlesValidationErrors],

    props: ['resourceName', 'resourceId', 'field'],

    data() {
        return {
            numbersText: '',
        }
    },

    computed: {
        displayValue: {
            get() {
                if (this.value === null || this.value === undefined || this.value === '') {
                    return ''
                }

                return numeral(this.value).format(this.currentField.format || '0,0')
            },

            set(newValue) {
                const raw = numeral(newValue).value()
                const normalized = raw === null || Number.isNaN(raw) ? '' : Math.round(raw)

                this.value = normalized === '' ? '' : normalized
                this.updateNumbersText(normalized)
                this.emitFieldValueChange(this.fieldAttribute, this.value === '' ? '' : this.value)
            },
        },
    },

    methods: {
        setInitialValue() {
            this.value = this.field.value ?? ''
            this.updateNumbersText(this.value)
        },

        fill(formData) {
            formData.append(this.field.attribute, this.value === '' ? '' : this.value)
        },

        handleInput(event) {
            this.displayValue = event.target.value
        },

        updateNumbersText(value) {
            if (value === '' || value === null || value === undefined) {
                this.numbersText = ''

                return
            }

            const raw = Number(value)

            if (! Number.isFinite(raw)) {
                this.numbersText = ''

                return
            }

            const unit = this.currentField.moneyUnit || ''
            const text = pn.convert(raw)

            this.numbersText = unit ? `${text} ${unit}` : text
        },
    },
}
</script>
